export default __webpack_public_path__ + "static/media/headerImg.99204458.webp";